import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'searchResultSubjectBirthYear'
})
@Injectable({
  providedIn: 'root'
})
export class SearchResultSubjectBirthYearPipe implements PipeTransform {

  transform(src: any): number | string {
    const cleanRC = src.toString().replace(/\//g, '').trim();

    if (!/^\d{9,10}$/.test(cleanRC)) {
      return "Nenalezeno";
    }

    const month = parseInt(cleanRC.substring(2, 4), 10);
    const day   = parseInt(cleanRC.substring(4, 6), 10);

    // Valid month ranges: 1–12 (men), 21–32 (men overflow), 51–62 (women), 71–82 (women overflow)
    const normalizedMonth = month > 70 ? month - 70
                          : month > 50 ? month - 50
                          : month > 20 ? month - 20
                          : month;
    if (normalizedMonth < 1 || normalizedMonth > 12) {
      return "Nenalezeno";
    }

    if (day < 1 || day > 31) {
      return "Nenalezeno";
    }

    // 10-digit RC must be divisible by 11
    if (cleanRC.length === 10 && parseInt(cleanRC, 10) % 11 !== 0) {
      return "Nenalezeno";
    }

    let year = parseInt(cleanRC.substring(0, 2), 10);

    if (cleanRC.length === 9) {
      year += 1900;
    } else {
      if (year > 53) {
        year += 1900;
      } else {
        year += 2000;
      }
    }

    return year;
  }
}
